import { render, staticRenderFns } from "./RecordDialog.vue?vue&type=template&id=53071ffc&scoped=true"
import script from "./RecordDialog.vue?vue&type=script&lang=js"
export * from "./RecordDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordDialog.vue?vue&type=style&index=0&id=53071ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53071ffc",
  null
  
)

export default component.exports